module.exports = __webpack_public_path__ + "img/uploading.e6b334f3.svg";